import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c065de5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "the-site-description has-background-contents shadow" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "the-site-description-header" }
const _hoisted_4 = { class: "the-site-description-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheListAbout = _resolveComponent("TheListAbout")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('siteDescription.title')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('siteDescription.description')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_TheListAbout, { class: "the-site-description-list" })
    ])
  ]))
}